<div [ngSwitch]="status">
  <span *ngSwitchCase="0" class="text-warning" data-bs-toggle="tooltip" data-bs-html="true" [title]="'<strong>Motivo:</strong> ' + error">No procesado</span>
  <span *ngSwitchCase="1" class="text-success">Exitoso</span>
  <span *ngSwitchCase="2" class="text-danger" data-bs-toggle="tooltip" data-bs-html="true" [title]="'<strong>Motivo:</strong> ' + error">Rechazado</span>
  <span *ngSwitchCase="3" class="text-info">Reembolsado</span>
  <span *ngSwitchDefault class="text-light">Cancelado</span>
</div>
